import Template from '../components/template'
import { Link, Navigate, Outlet, useMatch, useParams } from 'react-router-dom'
import React, { useEffect, useMemo, useState } from 'react'
import { getWorkflowConfig, hasWorkflowStepAccess } from '../workflows/util'
import { WorkflowConfig } from '../lib/types'
import StepTypeLabels from './labels'
import InputStep from './input'
import ReviewStep from './review/review'
import ArbitrateStep from './arbitrate'
import ErrorMsg from '../components/error-msg'
import auth from '../lib/auth'

export default function WorkflowStepPage() {
    const { id, stepIndex } = useParams()
    const [config, setConfig] = useState<WorkflowConfig | null>(null)
    const [err, setErr] = useState('')
    const [viewType, setViewType] = useState('all')
    const [page, setPage] = useState(0)
    const match = useMatch('/workflows/:id/steps/:stepIndex')

    const userRoles = useMemo(() => config ? config.users.filter(item => item.id === Number(auth.user?.sub)) : [], [config])
    useEffect(() => {
        getWorkflowConfig(Number(id))
            .then(setConfig)
            .catch((err) => setErr(err.message || err))
    }, [id])

    const step = useMemo(() => config?.steps[Number(stepIndex)], [config, stepIndex])
    if (config && !hasWorkflowStepAccess(config, Number(stepIndex), userRoles))
        return <Navigate to={'/workflows/' + id} />

    return (
        <Template auth>
            <div className='container mx-auto mt-10'>
                {match && (
                    <div className='mb-3'>
                        <Link to={'/workflows/' + id}>
                            <i className='lni lni-chevron-left' /> Back to Workflow
                        </Link>
                    </div>
                )}
                <Outlet context={[viewType, setViewType]} />
                {err && <ErrorMsg error={err} />}
                {match && step && (
                    <div>
                        <div className='flex mb-5'>
                            <h1 className='mb-0'>
                                Step {Number(stepIndex) + 1}: {step.name}
                            </h1>
                            <span className='ml-10 bg-gray-100 px-3 py-1 rounded-full text-sm'>
                                {StepTypeLabels[step.type]}
                            </span>
                        </div>

                        {step.type === 'input' && <InputStep step={step} />}
                        {step.type === 'input-cycle' && <InputStep step={step} />}
                        {step.type === 'correct' && <InputStep step={step} />}
                        {step.type === 'correct-cycle' && <InputStep step={step} />}
                        {step.type === 'approve' && (
                            <ReviewStep
                                step={step}
                                viewType={viewType}
                                setViewType={setViewType}
                                page={page}
                                setPage={setPage}
                            />
                        )}
                        {step.type === 'review' && (
                            <ReviewStep
                                step={step}
                                viewType={viewType}
                                setViewType={setViewType}
                                page={page}
                                setPage={setPage}
                            />
                        )}
                        {step.type === 'arbitrate' && (
                            <ArbitrateStep
                                step={step}
                                viewType={viewType}
                                setViewType={setViewType}
                                page={page}
                                setPage={setPage} 
                            />
                        )}
                        {/*{step.type === 'edit' && <EditStep step={step} />}*/}
                    </div>
                )}
            </div>
        </Template>
    )
}
